import { render, staticRenderFns } from "./PageMiniGamesPlay.vue?vue&type=template&id=5f5eb876&"
import script from "./PageMiniGamesPlay.vue?vue&type=script&lang=js&"
export * from "./PageMiniGamesPlay.vue?vue&type=script&lang=js&"
import style0 from "./PageMiniGamesPlay.vue?vue&type=style&index=0&id=5f5eb876&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports